<header
  class="page-header"
  [ngClass]="extraClass"
  [class.page-header--substrate]="hasSubstrate"
  [class.page-header--full-height]="isFullHeight"
  [style.background-image]="
    img ? 'url(' + img + ')' : 'linear-gradient(253deg, #009fdf, #005aa8)'
  "
  [style.background-color]="color ? color : ''"
  role="presentation"
>
  @if (item) {
    <div class="page-header__inner container">
      @if (item.breadcrumbs?.length) {
        <div class="page-header__breadcrumbs">
          <app-breadcrumbs [breadcrumbs]="item.breadcrumbs"></app-breadcrumbs>
        </div>
      }
      @if (item.title) {
        <h1 class="page-header__title">
          {{ item.title }}
        </h1>
      }
      @if (item.short_content) {
        <p class="page-header__text">
          {{ item.short_content }}
        </p>
      }
      <ng-content></ng-content>
    </div>
  }
</header>
